import {
  GET_STAGES_REQUEST,
  GET_STAGES_SUCCESS,
  GET_STAGES_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: [],
  status: statusType.IDLE
}

const pipeline = (state = initial, action) => {
  switch (action.type) {
    case GET_STAGES_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_STAGES_SUCCESS:
      return {
        data: action.payload,
        status: statusType.SUCCESS
      }

    case GET_STAGES_FAILURE:
      return {
        error: action.error,
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default pipeline
